// extracted by mini-css-extract-plugin
export var tags = "teaquiz-module--tags--2Lo4o";
export var nav = "teaquiz-module--nav--6rwRP";
export var teaquiz = "teaquiz-module--teaquiz--8tVP6";
export var points = "teaquiz-module--points--R4R5o";
export var scoreSection = "teaquiz-module--scoreSection--1acxc";
export var notesSection = "teaquiz-module--notesSection--3IG5a";
export var questionArea = "teaquiz-module--questionArea--3L8l9";
export var questionSection = "teaquiz-module--questionSection--2nRKo";
export var questionTitle = "teaquiz-module--questionTitle--29Y8x";
export var questionCount = "teaquiz-module--questionCount--1tj-Z";
export var questionText = "teaquiz-module--questionText--22ekc";
export var answerSection = "teaquiz-module--answerSection--80G9N";
export var correct = "teaquiz-module--correct--2Tmdq";
export var incorrect = "teaquiz-module--incorrect--3-x-v";